import React from 'react';
import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';
import ServiceCategoriesGrid from '../components/ServiceCategoriesGrid';
import './ServicePage.css';

const ServiceCategoriesGridPage = () => (
  <div className="about-page">
    <BannerWithBreadcrumb
      title="All Services"
      breadcrumbItems={[
        { label: 'Home', link: '/' },
        { label: 'All Services' }
      ]}
    />
    <section className="content-section">
      <h2 className="text-center mb-4">Browse All Services</h2>
      <ServiceCategoriesGrid />
    </section>
  </div>
);

export default ServiceCategoriesGridPage;
